import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/views/AppMain/index.vue';
Vue.use(Router);

/**
 * 创建组件后 在声明组件路由时 建议 添加name属性
* {
    path: '/xxxx',
    component: () => import('@/views/xxxx/xxxx'),
    name: 'xxxx',
    meta: {
	 title: 'xxxx',
    }
  }

  需要 缓存页面的组件 在其meta属性下 加 keepAlive: true,
 */

export const routes = [
	{
		path: '/',
		redirect: '/index',
	},
	{
		path: '/index',
		redirect: '/home/index',
		meta: {
			title: '西顿总裁直通车',
		},
	},
	{
		path: '/suggestion',
		component: Main,
		redirect: '/suggestion/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/suggestion/index'),
				name: 'suggestion',
				meta: {
					title: '合理化建议-西顿总裁直通车',
					keepAlive: true,
					isAuth: true,
				},
			},
		],
	},
	{
		path: '/complaint',
		component: Main,
		redirect: '/complaint/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/complaint/index'),
				name: 'complaint',
				meta: {
					title: '投诉举报-西顿总裁直通车',
					keepAlive: true,
					isAuth: true,
				},
			},
		],
	},
	{
		path: '/commend',
		component: Main,
		redirect: '/commend/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/commend/index'),
				name: 'complaint',
				meta: {
					title: '表彰表扬-西顿总裁直通车',
					keepAlive: true,
					isAuth: true,
				},
			},
		],
	},
	{
		path: '/feedbackFile',
		component: Main,
		redirect: '/feedbackFile/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/feedbackFile/index'),
				name: 'feedbackFile',
				meta: {
					title: '问题反馈和处理机制-西顿总裁直通车',
					keepAlive: true,
					// isAuth: true,
				},
			},
		],
	},
	{
		path: '/suggestionDetail',
		component: Main,
		redirect: '/suggestionDetail/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/suggestionDetail/index'),
				name: 'suggestionDetail',
				meta: {
					title: '合理化建议详情-西顿总裁直通车',
					keepAlive: false,
					isAuth: true,
				},
			},
		],
	},
	{
		path: '/commendDetail',
		component: Main,
		redirect: '/commendDetail/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/commendDetail/index'),
				name: 'commendDetail',
				meta: {
					title: '表彰表扬详情-西顿总裁直通车',
					keepAlive: false,
					isAuth: true,
				},
			},
		],
	},
	{
		path: '/complaintDetail',
		component: Main,
		redirect: '/complaintDetail/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/complaintDetail/index'),
				name: 'complaintDetail',
				meta: {
					title: '投诉举报详情-西顿总裁直通车',
					keepAlive: false,
					isAuth: true,
				},
			},
		],
	},
	{
		path: '/home',
		component: Main,
		redirect: '/home/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/home/index'),
				name: 'Home',
				meta: {
					title: '西顿总裁直通车',
					keepAlive: false,
				},
			},
		],
	},
	{
		path: '/bannerFile',
		component: Main,
		redirect: '/bannerFile/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/bannerFile/index'),
				name: 'bannerFile',
				meta: {
					title: '西顿总裁直通车',
					keepAlive: false,
				},
			},
		],
	},
	{
		path: '/my',
		component: Main,
		redirect: '/my/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/my/index.vue'),
				name: 'My',
				meta: {
					isFoot: true,
					title: '我的-西顿总裁直通车',
					isAuth: true,
					keepAlive: false,
				},
				children: [
					{
						path: 'change',
						component: () => import('@/views/my/components/change.vue'),
						name: 'change',
						meta: {
							title: '修改密码-西顿总裁直通车',
							isFoot: true,
							isAuth: true,
						},
					},
					{
						path: 'feedback',
						component: () => import('@/views/my/components/feedback.vue'),
						name: 'feedback',
						meta: {
							title: '我的问题反馈-西顿总裁直通车',
							isFoot: true,
							isAuth: true,
							keepAlive: false,
						},
					},
					{
						path: 'information',
						component: () => import('@/views/my/components/information.vue'),
						name: 'information',
						meta: {
							title: '个人信息-西顿总裁直通车',
							isFoot: true,
							isAuth: true,
						},
					},
				],
			},
		],
	},
	{
		path: '/informations',
		component: Main,
		redirect: '/informations/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/my/components/H5/information.vue'),
				name: 'informations',
				meta: {
					title: '个人信息-西顿总裁直通车',
					keepAlive: true,
					isAuth: true,
					isFoot: true,
				},
			},
		],
	},
	{
		path: '/changes',
		component: Main,
		redirect: '/changes/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/my/components/H5/change.vue'),
				name: 'changes',
				meta: {
					isFoot: true,
					title: '修改密码-西顿总裁直通车',
					keepAlive: true,
					isAuth: true,
				},
			},
		],
	},
	{
		path: '/feedbacks',
		component: Main,
		redirect: '/feedbacks/index',
		children: [
			{
				path: 'index',
				component: () => import('@/views/my/components/H5/feedback.vue'),
				name: 'feedbacks',
				meta: {
					title: '我的问题反馈-西顿总裁直通车',
					keepAlive: true,
					isAuth: true,
				},
			},
		],
	},
	{
		path: '/login',
		component: () => import('@/views/login/index'),
		name: 'Login',
		meta: {
			title: '登录-西顿总裁直通车',
			keepAlive: true,
		},
	},
	{
		path: '*',
		component: () => import('@/components/NotFound'),
	},
];
const router = new Router({
	mode: 'history',
	routes,
	base: process.env.BASE_URL,
});

router.beforeEach((to, from, next) => {
	window.scrollTo({
		top: 0,
	});
	if (to.meta.isAuth) {
		// 判断当前路由是否需要进行权限控制
		if (localStorage.getItem('token')) {
			next();
		} else {
			next('/login');
		}
	} else {
		next();
	}
});

export default router;
